// extracted by mini-css-extract-plugin
export default {"footerWrapper":"styles_footerWrapper__CywRc","footerWrapper_cefx":"styles_footerWrapper_cefx__YluOb","containerLogos":"styles_containerLogos__Lm54i"};